import { Paginator } from "./Paginator";
import { EntityModalWindow } from "./EntityModalWindow";
import { Filter } from "./Filter";

export const Section = (() => {

    return class Section {
        constructor(title, paginator_grouped_flag=false) {
            this.title = title;

            this.container = $(`.data-view.${title}`);

            this.modalActions = new EntityModalWindow(this.title);
            this.filter = Filter.start(this.title, {limit:10, page:1});
            this.paginator = new Paginator(title, 10, paginator_grouped_flag, this.filter);
            this.filter.paginator = this.paginator
            this.filter.main()
            $(document).on('filter_reset', (e) => {
                if (this.container.hasClass('d-block')) {
                    this.paginator.checkBorders();
                }
            });
        }

        getName() {
            return this.title;
        }
        show() {
            this.container.removeClass('d-none');
            this.container.addClass('d-block');
            this.paginator.showPaginator();
            this.paginator.checkStatus();
            this.filter.showFilter();

            return this;
        }
        hide() {
            this.container.addClass('d-none');
            this.container.removeClass('d-block');
            this.paginator.hidePaginator();
            return this;
        }

        update() {
            this.filter.main();
            return this;
        }
    }
})();
